// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"950":"0a3dab8b9f366687","1834":"579c27df3920e05c","1971":"6d76c67b776ee827","2458":"3acb2a9d0e295029","4571":"4094a4486b123b9e","9530":"8b0ff5d52047659f"}[chunkId] + ".css";
};